if (!customElements.get('plexie-destination-selector')) {
  customElements.define(
    'plexie-destination-selector',
    class PlexieDestinationSelector extends HTMLElement {
      constructor() {
        super();
        this.storageKey = 'plexie_destination';
        this.dialog = this.querySelector('[role="dialog"]');
        this.closeButton = this.querySelector('[data-plexie-destination-close]');
        this.choiceButtons = Array.from(this.querySelectorAll('[data-plexie-country]'));
        this.previousFocus = null;
        this.hasSavedDestination = Boolean(this.getSavedDestination());

        this.openButtons = Array.from(document.querySelectorAll('[data-plexie-destination-open]'));
        this.openButtons.forEach((button) => button.addEventListener('click', () => this.open(true)));
        this.closeButton?.addEventListener('click', () => this.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog && this.hasSavedDestination) this.close();
        });
        this.choiceButtons.forEach((button) => {
          button.form?.addEventListener('submit', () => this.saveAndLock(button.dataset.plexieCountry));
        });
        document.addEventListener('keydown', (event) => this.onKeyDown(event));

        if (this.dataset.designMode !== 'true' && !this.hasSavedDestination) {
          window.requestAnimationFrame(() => this.open(false));
        }
      }

      getSavedDestination() {
        try {
          const stored = window.localStorage.getItem(this.storageKey);
          if (stored) return stored;
        } catch (error) {
          // Cookies remain available when local storage is restricted.
        }

        const match = document.cookie.match(/(?:^|; )plexie_destination=(JP|KR)(?:;|$)/);
        return match ? match[1] : '';
      }

      saveAndLock(countryCode) {
        if (!countryCode) return;

        try {
          window.localStorage.setItem(this.storageKey, countryCode);
        } catch (error) {
          // Continue with the cookie fallback.
        }

        document.cookie = `plexie_destination=${countryCode}; path=/; max-age=31536000; SameSite=Lax`;
        this.choiceButtons.forEach((button) => {
          button.disabled = true;
        });
        this.dialog?.setAttribute('aria-busy', 'true');
      }

      open(fromTrigger) {
        if (!this.dialog) return;

        this.previousFocus = fromTrigger ? document.activeElement : null;
        this.hasSavedDestination = Boolean(this.getSavedDestination());
        this.closeButton?.toggleAttribute('hidden', !this.hasSavedDestination);
        this.dialog.removeAttribute('hidden');
        document.body.classList.add('plexie-destination-open');

        const firstEnabledChoice = this.choiceButtons.find((button) => !button.disabled);
        window.requestAnimationFrame(() => firstEnabledChoice?.focus());
      }

      close() {
        if (!this.dialog || !this.hasSavedDestination) return;

        this.dialog.setAttribute('hidden', '');
        document.body.classList.remove('plexie-destination-open');
        this.previousFocus?.focus();
      }

      onKeyDown(event) {
        if (!this.dialog || this.dialog.hasAttribute('hidden')) return;

        if (event.key === 'Escape' && this.hasSavedDestination) {
          event.preventDefault();
          this.close();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = Array.from(
          this.dialog.querySelectorAll('button:not([disabled]):not([hidden]), a[href], input:not([type="hidden"])')
        );
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  );
}
